export default __webpack_public_path__ + "static/media/tick-round.4cafd2bc.svg";